export const LIGHT_COLORS = [
  { id: "color_1", accent: "#1D7AFC", text: "#FFFFFF" },
  { id: "color_2", accent: "#2898BD", text: "#FFFFFF" },
  { id: "color_3", accent: "#22A06B", text: "#FFFFFF" },
  { id: "color_4", accent: "#82B536", text: "#FFFFFF" },
  { id: "color_5", accent: "#B38600", text: "#FFFFFF" },
  { id: "color_6", accent: "#8270DB", text: "#FFFFFF" },
  { id: "color_7", accent: "#CD519D", text: "#FFFFFF" },
  { id: "color_8", accent: "#E2483D", text: "#FFFFFF" },
  { id: "color_9", accent: "#E56910", text: "#FFFFFF" },
  { id: "color_10", accent: "#85B8FF", text: "#1C2B41" },
  { id: "color_11", accent: "#9DD9EE", text: "#1E3137" },
  { id: "color_12", accent: "#7EE2B8", text: "#1C3329" },
  { id: "color_13", accent: "#B3DF72", text: "#28311B" },
  { id: "color_14", accent: "#F5CD47", text: "#332E1B" },
  { id: "color_15", accent: "#B8ACF6", text: "#2B273F" },
  { id: "color_16", accent: "#F797D2", text: "#3D2232" },
  { id: "color_17", accent: "#FD9891", text: "#42221F" },
  { id: "color_18", accent: "#FEC195", text: "#38291E" },
  { id: "color_19", accent: "#121212", text: "#FFFFFF" },
  { id: "color_20", accent: "#2C3E5D", text: "#FFFFFF" },
  { id: "color_21", accent: "#F1F2F4", text: "#252525" },
];

export const DARK_COLORS = [
  { id: "color_1", accent: "#388BFF", text: "#050505" },
  { id: "color_2", accent: "#42B2D7", text: "#050505" },
  { id: "color_3", accent: "#2ABB7F", text: "#050505" },
  { id: "color_4", accent: "#5B7F24", text: "#050505" },
  { id: "color_5", accent: "#CF9F02", text: "#050505" },
  { id: "color_6", accent: "#8F7EE7", text: "#050505" },
  { id: "color_7", accent: "#DA62AC", text: "#050505" },
  { id: "color_8", accent: "#F15B50", text: "#050505" },
  { id: "color_9", accent: "#E56910", text: "#050505" },
  { id: "color_10", accent: "#0055CC", text: "#E9F2FF" },
  { id: "color_11", accent: "#206A83", text: "#E9F2FF" },
  { id: "color_12", accent: "#216E4E", text: "#E9F2FF" },
  { id: "color_13", accent: "#4C6B1F", text: "#E9F2FF" },
  { id: "color_14", accent: "#7F5F01", text: "#E9F2FF" },
  { id: "color_15", accent: "#5E4DB2", text: "#E9F2FF" },
  { id: "color_16", accent: "#943D73", text: "#E9F2FF" },
  { id: "color_17", accent: "#AE2E24", text: "#E9F2FF" },
  { id: "color_18", accent: "#A54800", text: "#E9F2FF" },
  { id: "color_19", accent: "#3A3A3A", text: "#FFFFFF" },
  { id: "color_20", accent: "#6882A8", text: "#FFFFFF" },
  { id: "color_21", accent: "#4A4A4A", text: "#FFFFFF" },
];

export const DEFAULT_COLORS = {
  light: [
    LIGHT_COLORS[0],
    LIGHT_COLORS[5],
    LIGHT_COLORS[8],
    LIGHT_COLORS[9],
    LIGHT_COLORS[14],
    LIGHT_COLORS[17],
    LIGHT_COLORS[18],
  ],
  dark: [
    DARK_COLORS[0],
    DARK_COLORS[5],
    DARK_COLORS[8],
    DARK_COLORS[9],
    DARK_COLORS[14],
    DARK_COLORS[17],
    DARK_COLORS[18],
  ],
};
